import { useEffect } from 'react'
import { PagePathService } from '@/src/services/PagePathService'
import { useLoginUser } from '@/src/views/states/LoginUser'
import { useRouter } from 'next/router'
import { Props } from './Layout'
import { NftState, useArcadeMachinesQuery } from '../../query.generated'
import { useProcessingContactsContext } from '../../../../states/ProcessingContactsContext'
import { DISABLED_AMS } from '@/src/assets/constants'

export const useProps = (): Props => {
  const loginUser = useLoginUser()
  const { data, refetch } = useArcadeMachinesQuery({
    variables: {
      where: {
        userId: { equals: loginUser.loginUser?.id ?? '' },
        destroyedAt: { equals: null },
      },
    },
  })
  const router = useRouter()

  const { depositingArcadeMachines, withdrawingArcadeMachines } = useProcessingContactsContext()

  // useProcessingContactsContextは定期実行されているのでAMの状態が変わったことを検知してrefechするための処理
  const isDepositingOrWithdrawing = depositingArcadeMachines.length === withdrawingArcadeMachines.length

  useEffect(() => {
    refetch()
  }, [isDepositingOrWithdrawing, refetch])

  return {
    items:
      data?.arcadeMachines.map<Props['items'][number]>((am) => {
        const disabledAM = DISABLED_AMS.includes(am.game)
        const inAkiverse = am.state === NftState.InAkiverse
        return {
          id: am.id,
          imageUrl: am.metadata.withoutAccImageUrl ?? '',
          onClick: () => router.push(PagePathService.arcadeMachineManagerShowCaseDetail(am.id)),
          name: am.metadata.name,
          installable: !disabledAM && inAkiverse && !am.gameCenterId && am.feverSparkRemain !== 0,
          extractable: !disabledAM && inAkiverse && !!am.extractInfo.extractCode,
          dismantable: !disabledAM && inAkiverse && am.feverSparkRemain !== null,
          state: am.state,
          energy: !disabledAM ? am.energy : undefined,
          maxEnergy: !disabledAM ? am.maxEnergy : undefined,
          extractedEnergy: !disabledAM ? am.extractedEnergy : undefined,
          feverSparkRemain: am.feverSparkRemain ?? null,
        }
      }) ?? [],
    maxArcadeMachineCounts: data?.arcadeMachines.length ?? 0,
  }
}
